import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

document.addEventListener("DOMContentLoaded", function() {
    const sliders = document.querySelectorAll('.swiper-testimonials');

    sliders.forEach(function(slider) {
        const sliderId = slider.getAttribute('data-slider-id');
        const slidesPerPage = parseInt(slider.getAttribute('data-slides-per-page'), 10);

        const container = slider.closest('.swiper-container-parent');

        const nextButton = container.querySelector(`.swiper-button-next-testimonials[data-slider-id="${sliderId}"]`);
        const prevButton = container.querySelector(`.swiper-button-prev-testimonials[data-slider-id="${sliderId}"]`);

        new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: slidesPerPage,
            spaceBetween: 30,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                992: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: slidesPerPage,
                },
            },
        });
    });
});
